import { LayoutConfigModel } from './layout-config.model';

export const Layouts: LayoutConfigModel[] = [
  {
    name: 'pay',
    url: 'pay.nl',
    layoutModel: {
      color: '',
      logo: 'assets/images/logos/pay_filled.svg',
      font: '',
      text: '',
    },
  },
  {
    name: 'raket',
    url: 'raket.space',
    layoutModel: {
      color: '#E20E24',
      logo: 'assets/images/logos/rocket.png',
      font: '',
      text: 'login-page.header.name.raket',
    },
  },
];
